import { exists } from '@/api'

export interface BatchTrcBooksOrderDataCreateCondition {
  traderCode: string
  buyBranch: string
  isOutputOrdered: boolean
  orderDateFrom: string
  orderDateTo: string
  memo: string
}

export function BatchTrcBooksOrderDataCreateConditionFromJSON(
  json: any
): BatchTrcBooksOrderDataCreateCondition {
  const _json = JSON.parse(json)

  return {
    traderCode: exists(_json, 'trader_code') ? _json.trader_code : '',
    buyBranch: exists(_json, 'buy_branch') ? _json.buy_branch : '',
    isOutputOrdered: exists(_json, 'is_output_ordered')
      ? _json.is_output_ordered
      : false,
    orderDateFrom: exists(_json, 'order_date_from')
      ? _json.order_date_from
      : '',
    orderDateTo: exists(_json, 'order_date_to') ? _json.order_date_to : '',
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
